import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CoreSplitter from '@components-clean/core/core-splitter';
import CardGrid from '@components-clean/core/grid/card-grid';
import { GridViewMenuItem } from '@components-clean/core/grid/grid-menu/grid-view-menu';
import { GridDummyColumns, GridDummyData } from '@pages-clean/dummy-page/dummy-page.data';
import { GridFullView, GridViewOptions, SplitterOrientation } from '@utils/constants';

const CardGridPage = () => {
    const { t } = useTranslation();

    const [currentView, setCurrentView] = useState<GridViewOptions>(GridFullView.full);

    const isFullView = currentView === GridFullView.full;

    const gridViewOptions: GridViewMenuItem[] = [
        {
            label: t('ra:fullView'),
            onClick: () => setCurrentView(GridFullView.full),
            icon: (
                <FontAwesomeIcon
                    icon={['fas', 'square']}
                    fontSize={18}
                    className="k-ml-1px k-mt--1px"
                    style={{ transform: 'scale(1.15,1)' }}
                />
            ),
            isActive: currentView === GridFullView.full,
        },
        {
            label: t('ra:topView'),
            onClick: () => setCurrentView(SplitterOrientation.vertical),
            icon: <FontAwesomeIcon icon={['far', 'window-maximize']} fontSize={18} className="k-mt--1px" />,
            isActive: currentView === SplitterOrientation.vertical,
        },
    ];

    const grid = (
        <CardGrid
            title="Core OPRA Grid"
            maxHeight={isFullView ? 'calc(100vh - 136px)' : 'auto'}
            testDataId="dummy-grid"
            data={GridDummyData}
            columns={GridDummyColumns}
            gridViewOptions={gridViewOptions}
            canEdit
            filterable={false}
        />
    );

    return isFullView ? (
        grid
    ) : (
        <div style={{ height: 'calc(100vh - 132px)' }}>
            <CoreSplitter
                className="!k-h-full"
                orientation={currentView}
                alignmentValues={[
                    {
                        size: '50%',
                        min: '30%',
                    },
                    {},
                ]}
                data-testid="test-splitter"
            >
                <div className="k-h-full">{grid}</div>
                <div>
                    Duis fermentum rutrum fringilla. Donec quis orci sit amet ex elementum lacinia. Suspendisse bibendum
                    lectus tincidunt efficitur mattis. Praesent tincidunt sapien ante. Mauris quis quam arcu. Curabitur
                    eu cursus nisl, sit amet pharetra massa. In imperdiet diam id purus maximus interdum id in nisl.
                    Curabitur porta neque ut augue pretium bibendum. Orci varius natoque penatibus et magnis dis
                    parturient montes, nascetur ridiculus mus. Phasellus ut condimentum leo. Nulla in ipsum id lacus
                    lobortis ultricies. Sed consectetur leo in lectus finibus laoreet vitae nec massa.
                </div>
            </CoreSplitter>
        </div>
    );
};

export default CardGridPage;
